import React, { Component , Fragment } from "react";
import _ from "lodash";
import { DateTime } from "luxon";
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import FormFlowWrapper from "../../theme/wrappers/FormFlowWrapper";
import { getJsonFromUrl } from "../../../utils/parseUrl";
import api from "../../../store/api";
import {
  toggleGlobalLoader,
  addErrorAlert,
} from "../../../store/calls/alertLoadingDispatch";
import {mountApplication} from "../../../store/calls/applicationData";
import formatters from "../../../utils/forms/formatters";
import Input from "../../theme/forms/Input";
import Indicative from "./Indicative";
import TelephoneNumber from "../../subcomponents/TelephoneNumber";

const USDFormatter = formatters.USDCurrency.formatter;

class IndicativeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      amortization_term: null,
      selected_index: 0,
      data: [],

    };
  }

  componentDidMount() {
    toggleGlobalLoader(true);
    const lead_id = this.props.match.params.projectLeadId;
    let query_params = getJsonFromUrl(window.location.href);

    api
      .get("/generate-indicative/", { lead_id, ...query_params })
      .then((res) => {
        // if (!res.data.length) return;

        this.setState({ data: res.data });
      })
      .catch((err) => {
        if (!err.response) {
          this.setState({
            error:
              "There seems to have been a connectivity issue, we couldn't complete the build process with our server.",
          });
        }

        if (_.get(err, "response.data.error")) {
          this.setState({ error: _.get(err, "response.data.error") });
        } else {
          this.setState({
            error:
              "Something went wrong, and we weren't able to build the indicative.",
          });
        }
      })
      .finally(() => {
        toggleGlobalLoader(false);
      });
  }

  renderTabs = () => {
    return (
      <div className="tabs is-centered mt-5 no-print">
        <ul>
          {this.state.data.map((d, i) => {
            if (i < 3)
              return (
                <li
                  className={i === this.state.selected_index ? "is-active" : ""}
                >
                  <a onClick={() => this.setState({ selected_index: i })}>
                    Option {i + 1}
                  </a>
                </li>
              );
          })}
        </ul>
      </div>
    );
  };

  handleApplyRequest = () => {
      const selectedIndicative = this.state.data[this.state.selected_index];
      mountApplication({
        indicative_id: selectedIndicative.indicative_id,
        project_id: this.props.focusedProject,
        indicativeData: {...selectedIndicative, id: selectedIndicative.indicative_id}
      }).then((applicationData) => {
        this.props.history.push(`/apply/${applicationData.id}`);
      })

  }

  render() {
    const { data } = this.state;

    if (!data.length || this.state.error)
      return (
        <FormFlowWrapper>
          {this.state.error && (
            <div className="card m-4 mt-6">
              <div className="content">
                <div
                  className="is-flex m-4 is-justify-content-center is-align-items-center"
                >
                  <span
                    className="icon has-text-danger is-size-2 m-2 mr-5 is-flex is-justify-content-center is-align-items-center"
                    onClick={() => {}}
                  >
                    <i className="far fa-times-circle" />
                  </span>
                  <h4 className="is-size-5 has-text-danger m-0">
                    {this.state.error}
                  </h4>
                </div>
              </div>
            </div>
          )}

          {/* HANDLE CASE OF NO FUNDERS */}
          {!data.length && !this.props.loaderOn && !this.state.error &&
          <div className="card m-4 mt-6">
            <div className="content">
              <div className="is-flex m-4 is-justify-content-center is-align-items-center is-flex-direction-column">
                  <span className="icon has-text-danger is-size-2 m-5 is-flex is-justify-content-center is-align-items-center">
                    <i className="far fa-times-circle" />
                  </span>
                <h4 className="is-size-5 has-text-primary mx-6" style={{width:'800px'}}>
                  Unfortunately, there were no matching Financing Products.
                </h4>
                <h4 className="is-size-6 has-text-secondary mx-6" style={{width:'800px'}}>
                  While your project is in one or more C-PACE program, we regret that no funder currently finances projects such as the one you have described.
                  While this could change soon, for immediate alternative financing solutions, write us at <a href="mailto:admin@pacefi.com ">admin@pacefi.com</a> or call us directly, at <TelephoneNumber />
                </h4>
                <div className="buttons mt-5">
                  <div className="button is-link is-outlined" onClick={() => window.location = '/my-projects'}>
                    Edit Project
                  </div>
                  <div className="button is-link is-outlined" onClick={() => window.location = '/'}>
                    Look up another address
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </FormFlowWrapper>
      );

    return (
      <FormFlowWrapper>
        {this.renderTabs()}

        {/* sba loan warning */}
        {!!Number(data[this.state.selected_index].sba_lien_exists) &&
        <div className="box has-background-warning mx-6">
          <p>
            Certain SBA loans strictly prohibit C-PACE financing on the related property.
            Please contact admin@cleanfi.com for clarification, or include the SBA loan information at the time of your application.
          </p>
        </div>
        }

        <div className="level mb-6 mx-6 no-print">
          <div className="level-left">
            {!!this.props.isAdmin &&
            <div className="level-item is-flex-direction-column is-align-items-flex-start ml-6">
                <h5 className="has-text-danger">ADMIN ONLY</h5>
                <h6>Funder: {_.get(  this.state.data[this.state.selected_index], 'loan_option.funder.name')}, id {_.get( this.state.data[this.state.selected_index], 'loan_option.funder.id')}</h6>
                <h6>Program: {_.get( this.state.data[this.state.selected_index], 'loan_option.pace_program.name')}, id {_.get( this.state.data[this.state.selected_index], 'loan_option.pace_program.id')}</h6>
              </div>
            }


          </div>
          <div className="level-right">
            <div className="level-item">
              <button
                  className="button is-info is-medium"
                  onClick={() => window.print()}
              >
                Print
              </button>
            </div>
            <div className="level-item">
              <button
                  className="button is-success is-medium"
                  onClick={this.handleApplyRequest}
              >
                Apply Now
              </button>
            </div>
          </div>
        </div>

        <Indicative data={data[this.state.selected_index]} />
      </FormFlowWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedProject: state.projectLeads.focusedProject,
  isAdmin: state.user.decodedTokenData.admin,
  loaderOn: state.session.globalLoaderOn,
});

export default connect(mapStateToProps)(IndicativeScreen);
